import { useDictionary } from '@wildscreen/core/src/core';
import * as React from 'react';

import styles from './noResults.module.scss';

export const NoResults: React.FC = () => {
  const { general } = useDictionary('en');
  return <div className={styles.noResults}>{general.noResultsFound}</div>;
};
